<template>
  <div class="auth-bg">
    <div class="container-fluid p-0">
      <div class="row g-0">
        <div class="col-xl-3 col-lg-4">
          <div class="p-4 pb-0 p-lg-5 pb-lg-0 auth-logo-section">
            <div class="text-white-50">
              <router-link :to="{ name: 'Home' }" custom v-slot="{ navigate }">
                <a
                  role="link"
                  title="Go to Homepage"
                  class="navbar-brand"
                  @click="navigate"
                  @keypress.enter="navigate"
                >
                  <img
                    :src="
                      $store.state.config.frontpoint +
                      '/storage/logo-newabc.png'
                    "
                    alt="newabc app"
                    class="m-1 my-2"
                    height="60"
                  />
                </a>
              </router-link>
              <p class="font-size-16 text-white">
                Networking the Educational World: Across Boundaries for
                Community-building.
              </p>
            </div>
            <div class="mt-auto" width="226px">
              <img
                :src="
                  $store.state.config.frontpoint + '/storage/Sign-up-amico.png'
                "
                alt="Sign up photo"
                class="auth-img"
                width="180%"
              />
            </div>
          </div>
        </div>
        <!-- end col -->
        <div class="col-xl-9 col-lg-8">
          <div class="authentication-page-content">
            <div class="d-flex flex-column h-100 px-4 pt-4">
              <div class="row justify-content-center my-auto">
                <div
                  class="col-sm-10 col-lg-8 col-xl-7 col-xxl-6 position-relative"
                >
                  <!-- SIGN UP -->
                  <mainSignUp v-if="$route.name == 'Signup'" class="signup" />

                  <!--ForgotPassword-->
                  <mainForgotPassword
                    v-else-if="$route.name == 'ForgotPassword'"
                    class="ForgotPassword"
                  />

                  <!-- ResetPassword -->
                  <mainResetPassword
                    v-else-if="
                      $route.name == 'ResetPassword' &&
                      $route.params.token.length > 5
                    "
                    class="resetpassword"
                  />

                  <!-- signin -->
                  <mainSignIn v-else class="signin" />
                </div>
                <!-- end col -->
              </div>
              <!-- end row -->
            </div>
          </div>
        </div>
        <!-- end col -->
      </div>
      <!-- end row -->
    </div>
    <!-- end container-fluid -->
    <elFooter />
  </div>
  <!-- end auth bg -->
</template>

<script>
import elFooter from "../../components/Footer.vue";
import mainSignIn from "./components/SignIn.vue";
import mainSignUp from "./components/SignUp.vue";
import mainResetPassword from "./components/ResetPassword.vue";
import mainForgotPassword from "./components/ForgotPassword.vue";

export default {
  name: "Sign",
  metaInfo() {
    return {
      title: "Home",
      titleTemplate: "%s | NEW ABC APP",
    };
  },
  components: {
    mainSignIn,
    mainSignUp,
    mainResetPassword,
    mainForgotPassword,
    elFooter,
  },

  data() {
    return {};
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$store.state.modules.account.user && !this.$route.params.token) {
        const account = JSON.parse(localStorage.account);
        if (account.status != "blocked") {
          this.$router.push({ name: "Dashboard" });
        } else {
          this.$router.push({ name: "Home" });
        }
      } else {
        this.$store.state.utils.loaded = true;
      }
    });
  },

  methods: {},
};
</script>
